module.exports = "<div class=\"info-popup\">\r\n  <h1 mat-dialog-title>{{ data.title }}</h1>\r\n  <div [innerHTML]=\"data.content\"></div>\r\n</div>\r\n"